<template>
  <div v-if="showFooter">
    <div :class="s.footer">
      <div :class="s.links">
        <!-- <router-link to="/tokushohou">特定商取引法に基づく表記</router-link> -->
        <router-link to="/policy">プライバシーポリシー</router-link>
        <router-link to="/terms">利用規約</router-link>
        <router-link to="/admin">管理者ログイン</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isOpenMenu: false,
      showFooter: false,
      visible: true,
    };
  },
  created() {
    this.handleFooter(this.$route);
  },
  watch: {
    $route(to) {
      this.handleFooter(to);
    },
  },
  computed: {
    path() {
      return this.$route.path;
    },
  },
  methods: {
    handleFooter(to) {
      if (to.path === '/' || to.path === '/sp') {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.footer {
  padding: 10px 0;
  width: 100%;
  background-color: #DDD4C1;
  font-family: var(--notoserif);
  text-align: center;
  z-index: 10;
  .text {
    padding: 10px 0;
    font-size: 24px;
    font-family: "Nunito Sans", serif;
    font-optical-sizing: auto;
    font-style: normal;
    font-weight: 750;
    color: black;
    font-variation-settings:
      "wdth" 115,
      "YTLC" 500;
  }
  .links {
    padding-bottom: 8px;
    font-size: 14px;
    @media (max-width: 576px) {
        font-size: 11px;
    }
    a {
      margin: 0 7px;
      color: black;
      text-decoration: none;
      word-break: break-word;
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media (max-width: 576px) {
  .footer {
    font-size: 14px;
  }
}
</style>
